// Modules
import { connect } from 'react-redux';
import Promise from 'bluebird';
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';

import { Page, PageContent, PageHeader, ActionSection } from 'components/page';
import { SortableTH, Table } from 'components/content-containers/tables';
import { alerts } from 'modules/alerts/actions';
import { didQueryUpdate } from 'utils/filter-utils';
import Filters from 'modules/filters/filters';
import Pager from 'components/widgets/pager/pager';
import Triage from 'services/data/triage';
import TriageRow from 'components/models/triage/triage-row';

import * as actions from './store/actions';


class TriageTab extends React.Component {
  static propTypes = {
    triageItems: PropTypes.array,
    currentUser: PropTypes.object.isRequired,
    query: PropTypes.object,
    fetching: PropTypes.bool,
    count: PropTypes.number
  };

  constructor() {
    super();
    this.search = this.search.bind(this);

    this.filterConfig = {
      basic: [],
      advanced: [
        ['company', 'team', 'ticket', 'claimedBy', 'contact',],
        ['date', 'hostname', 'trigger', 'from', 'subject'],
        ['triageStatus', 'triageType', 'phoneNumber']
      ],
      defaults: {
        triageType: ['email', 'monitoringalert', 'call'],
        triageStatus: ['Active', 'Resolved', 'Archived', 'After Hours'] // eslint-disable-line quote-props
      }
    };
  }

  componentWillReceiveProps(nextProps) {
    if (didQueryUpdate(nextProps, this.props)) this.search(nextProps.query);
  }

  componentWillUnmount() {
    actions.clearPageData();
  }

  search(query) {
    actions.set({ fetching: true });
    const fullQuery = _.defaultsDeep({}, Triage.formatQuery(query || this.props.query), Triage.defaultQuery);
    
    Promise.props({
      triageItems: Triage.find(fullQuery),
      count: Triage.count({ where: fullQuery.where })
    })
      .then((response) => {
        actions.set({ fetching: false, count: response.count, items: response.triageItems });
      })
      .catch(alerts.catchError);
  }

  render() {
    const { triageItems, count = 0, fetching, currentUser } = this.props;
    
    return (
      <Page>
        <PageHeader title="Triage">
          <ActionSection className="triage-filters">
            <Filters config={this.filterConfig} />
          </ActionSection>
        </PageHeader>
        <PageContent
          fetching={fetching}
          emptyText="No triage items, adjust your filters!"
          emptyTextIcon="svg/filter.svg"
          showEmptyText={!fetching && _.isEmpty(triageItems)}
          className="triage"
        >
          <Table className="collapse-table">
            <thead>
              <tr>
                <th></th>
                <SortableTH sortField="createdAt">Date</SortableTH>
                <th></th>
                <SortableTH sortField="claimedBy.firstName">Claim</SortableTH>
                <th>Payload</th>
                <th>Origin</th>
                <SortableTH sortField="company.name">Company</SortableTH>
                <SortableTH sortField="ticket.description">Ticket</SortableTH>
              </tr>
            </thead>
            <tbody>
              {_.map(triageItems, (item) =>
                <TriageRow item={item} key={`${item.type}-${item.id}`} currentUser={currentUser} />
              )}
            </tbody>
          </Table>
          <Pager count={count} />
        </PageContent>
      </Page>
    );
  }
}

// Exports
export default connect((state) => ({
  triageItems: state.triagePage.items,
  currentUser: state.auth.currentUser,
  query: state.location.query,
  fetching: state.triagePage.fetching,
  count: state.triagePage.count
}))(TriageTab);
